import React from 'react';
import Navigation from '../Navigation/Navigation';
import './Layout.css';
import Footer from './Footer/Footer';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Navigation />
      
      <main className="main">
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default Layout;